'use strict';

import React     from 'react';
import ReactDOM  from 'react-dom';
import App       from './App';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import registerServiceWorker from './registerServiceWorker';

if ( process.env.NODE_ENV !== 'production' ) {
  // Enable React devtools
  window.React = React;
}

ReactDOM.render(
    <MuiThemeProvider>
      <App />
    </MuiThemeProvider>,
    document.getElementById('app'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js